import { render } from "./multatema.vue?vue&type=template&id=5a6178fe&scoped=true"
import script from "./multatema.vue?vue&type=script&lang=js"
export * from "./multatema.vue?vue&type=script&lang=js"

import "./multatema.vue?vue&type=style&index=0&id=5a6178fe&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6178fe"]])

export default __exports__